const assignment = {
  0: {
    name: 'Edit Assignment',
    authRule: 'addTour' // TODO: update w/ Edit Assignment security rule
  },
  1: {
    name: 'Delete Assignment',
    authRule: 'deleteAssignment'
  }
};

export default assignment;
